import React from "react";
import './styleCss/ChangePass.css';
import { useState, useEffect, useRef } from "react";
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import {getInstance} from '../api/baseapi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import {
  textSearchBtn,
  textResetBtn,
  textCreateBtn,
  colorSearchBtn,
  colorResetBtn,
  colorCreateBtn,
  iconSearchBtn,
  iconResetBtn,
  iconCreateBtn,
  hoverSearchBtn,
  hoverResetBtn,
  hoverCreateBtn,
  textSaveBtn,
  textCancleBtn,
  colorSaveBtn,
  colorCancleBtn,
  hoverSaveBtn,
  hoverCancleBtn,
  colorEditBtns,
  hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import {
  alertEnterPassword,
  alertChangePassword,
  alertChangePasswordCase,
  alertConfirmSave,
  alertSaved,
  alertCancel,
  alertNotFound
} from "../components/alertValid/AlertValid.js"

function ChangePassword() {
  useButtonDynamicStyles(
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
  );

  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validation, setValidation] = useState({
    length: false,
    upperLowerCase: false,
    number: false,
    specialChar: false,
    match: false,
  });
  const [btnConfirm, setBtnConfirm] = useState(true);
  const token = useRef();
  const navigate = useNavigate();

  const validatePassword = (pwd, confirmPwd) => {
    const length = pwd.length >= 8;
    const upperLowerCase = /[a-z]/.test(pwd) && /[A-Z]/.test(pwd);
    const number = /\d/.test(pwd);
    const specialChar = /[!@#$%^&*()+]/.test(pwd);
    const match = pwd === confirmPwd;

    setValidation({ length, upperLowerCase, number, specialChar, match });
  };

  const handlePasswordChange = (e) => {
    const newPwd = e.target.value;
    setNewPassword(newPwd);
    validatePassword(newPwd, confirmPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    const confirmPwd = e.target.value;
    setConfirmPassword(confirmPwd);
    validatePassword(newPassword, confirmPwd);
  };

  useEffect(() => {
    const { length, upperLowerCase, number, specialChar, match } = validation;
    setBtnConfirm(!(length && upperLowerCase && number && specialChar && match));
  }, [validation]);

  async function handleClickConfirm() {
    if (!newPassword && !confirmPassword) {
      await alertEnterPassword();
    } else if (confirmPassword !== newPassword) {
      await alertChangePassword
    } else if (!validation?.upperLowerCase || !validation?.number || !validation?.specialChar || !validation?.length) {
      await alertChangePasswordCase
    } else {
      await sendConfirmPassword();
    }
  }

  useEffect(() => {
    token.current = new URLSearchParams(window.location.search).get("token");
    setEmailConfirmPass();
  }, []);

  const setEmailConfirmPass = async () => {
    try {
      const service = getInstance();
      const response = await service.post('/api/auth/forgotpw-info', {
        token: token.current,
      });
      if (response.data.status === 'success') {
        let dataEmail = response.data.data.email;
        setEmail(dataEmail);
      }
    } catch (error) {
      if(error?.response?.status == 400 && error?.response?.data?.code == 40001){
        Swal.fire({
          iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-expired.png">',
          title: 'Expired',
          html: 'Your verification link has already been used.',
          confirmButtonText: 'CLOSE',
        }).then((result) => { navigate('/login'); });
      }else if(error?.response?.status == 400 && error?.response?.data?.code == 40002) {
        Swal.fire({
          iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-expired.png">',
          title: 'Expired',
          html: 'To change your password, return to the login page and select "Forgot Password" to send a new email.',
          confirmButtonText: 'CLOSE',
        }).then((result) => { navigate('/login'); });
      }else {
        Swal.fire({
          iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-expired.png">',
          title: 'Error',
          html: 'Token is incorrect. ',
          confirmButtonText: 'CLOSE',
        }).then((result) => { navigate('/login'); });
      }
    }
  };

  async function sendConfirmPassword() {
    try {
      const service = getInstance();
      const response = await service.post('/api/auth/confirm-forgotpw', {
        token: token.current,
        newpassword: newPassword,
      });
      if (response.data.status === 'success') {
        Swal.fire({
          iconHtml: '<img src="https://img2.pic.in.th/pic/ic-success-green.png">',
          title: 'Your password has been changed successfully.',
          text: 'ยินดีด้วย คุณเปลี่ยนรหัสผ่านสำเร็จแล้ว สามารถเข้าสู่ระบบได้',
          confirmButtonText: 'LOGIN',
        }).then((result) => { navigate('/login'); });
      } else {
        Swal.fire({
          iconHtml: '<img src="https://img2.pic.in.th/pic/ic-warnning.png">',
          title: 'Error',
          text: 'ทำรายการไม่สำเร็จ',
          confirmButtonText: 'CLOSE',
        });
      }
    } catch (error) {
      if(error?.response?.status == 400 && error?.response?.data?.code == 40001){
        Swal.fire({
          iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-expired.png">',
          title: 'Expired',
          html: 'Your verification link has already been used.',
          confirmButtonText: 'CLOSE',
        }).then((result) => { navigate('/login'); });
      }else if(error?.response?.status == 400 && error?.response?.data?.code == 40002) {
        Swal.fire({
          iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-expired.png">',
          title: 'Expired',
          html: 'To change your password, return to the login page and select "Forgot Password" to send a new email.',
          confirmButtonText: 'CLOSE',
        }).then((result) => { navigate('/login'); });
      }else{
        Swal.fire({
          iconHtml: '<img src="https://img5.pic.in.th/file/secure-sv1/ic-expired.png">',
          title: 'Error',
          html: 'Token is incorrect. ',
          confirmButtonText: 'CLOSE',
        }).then((result) => { navigate('/login'); });
      }
      
    }
  }

  return (
    <div id="changePassword">
      <div className="container-fluid height100">
        <div className="row justify-content-center height100">
          <div className="col-12 flex-direction login02">
            <div className="card-login">
              <div className="row">
                <div className='col-12 d-flex justify-content-center'>
                  <img src="assets/icons/ic-fg-pass.png" className="ic-fg-pass" alt="" />
                </div>
                <div className="col-12 mt-3 mb-3 d-flex justify-content-center">
                  <label className="fontReg font-size05 line-height03 font-weight-bold colorBlack01">
                    CHANGE PASSWORD
                  </label>
                </div>
                <div className="box-changepass">
                  <div className="col-12 mt-2 mb-2">
                    <label className="fontReg font-size03 line-height03 font-weight-bold colorBlack01">
                      Email: {email}
                    </label>
                  </div>
                  <div className="col-12">
                    <label className="fontLight font-size03">New Password <span className="colorRed">*</span></label>
                    <div className="d-flex justify-content-between box-pass">
                      <input
                        value={newPassword}
                        onChange={handlePasswordChange}
                        type={visible1 ? "text" : "password"}
                        className="inp-pass fontLight font-size03"
                        id="new_password"
                        placeholder="ต้องมีทั้งตัวเลขและตัวอักษร อย่างน้อย 8 ตัว"
                        name="new_password" autoComplete="on"
                      />
                      <div className="p-2" onClick={() => setVisible1(!visible1)}>
                        {visible1 ? (
                          <FontAwesomeIcon icon={faEye} />
                        ) : (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <label className="fontLight font-size03">Confirm Password <span className="colorRed">*</span></label>
                    <div className="d-flex justify-content-between box-pass">
                      <input
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        type={visible2 ? "text" : "password"}
                        className="inp-pass fontLight font-size03"
                        id="confirm_password"
                        placeholder="กรุณายืนยันรหัสผ่านอีกครั้ง"
                        name="confirm_password" autoComplete="on"
                      />
                      <div className="p-2" onClick={() => setVisible2(!visible2)}>
                        {visible2 ? (
                          <FontAwesomeIcon icon={faEye} />
                        ) : (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        )}
                      </div>
                    </div>
                  </div>
                  <ul className="condi-pass mt-3">
                    <li>
                      <span style={{ color: validation.length ? '#5FB045' : 'gray' }}>●</span> At least 8 characters long
                    </li>
                    <li>
                      <span style={{ color: validation.upperLowerCase ? '#5FB045' : 'gray' }}>●</span> Uppercase and Lowercase letter
                    </li>
                    <li>
                      <span style={{ color: validation.number ? '#5FB045' : 'gray' }}>●</span> Contains a number
                    </li>
                    <li>
                      <span style={{ color: validation.specialChar ? '#5FB045' : 'gray' }}>●</span> Contains a special character (!@#$%^&*()+)
                    </li>
                    <li>
                      <span style={{ color: validation.match ? '#5FB045' : 'gray' }}>●</span> Passwords match
                    </li>
                  </ul>
                  <div className="col-12 mt-3 d-flex justify-content-center">
                    <button
                      onClick={handleClickConfirm}
                      className="btn-submit01 fontReg font-weight-bold font-size03"
                      disabled={btnConfirm}
                    >
                      CONFIRM
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;